import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const saved = localStorage.getItem('kazo_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('kazo_token');
    if (token) {
      authAPI.moi()
        .then(res => { setUser(res.data); localStorage.setItem('kazo_user', JSON.stringify(res.data)); })
        .catch(() => { localStorage.removeItem('kazo_token'); localStorage.removeItem('kazo_user'); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const connexion = async (email, mot_de_passe) => {
    const res = await authAPI.connexion({ email, mot_de_passe });
    localStorage.setItem('kazo_token', res.data.token);
    localStorage.setItem('kazo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const inscription = async (data) => {
    const res = await authAPI.inscription(data);
    localStorage.setItem('kazo_token', res.data.token);
    localStorage.setItem('kazo_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const deconnexion = () => {
    localStorage.removeItem('kazo_token');
    localStorage.removeItem('kazo_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, connexion, inscription, deconnexion }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
